import { parse, stringify } from '@vanillaes/csv'

class AsBuildReportLine {
    constructor(nmr, rptimeposition, nextrptimeposition) {
        this.heading = 0;
        if (nextrptimeposition) {
            this.heading = this.getHeading(rptimeposition.xspray, rptimeposition.yspray, nextrptimeposition.xspray, nextrptimeposition.yspray);
        }
        this.data = [
            nmr,
            rptimeposition.logReference || "",
            rptimeposition.timestamp,
            rptimeposition.latitudeSpray,
            rptimeposition.longitudeSpray,
            rptimeposition.xspray,
            rptimeposition.yspray,
            this.heading,
            rptimeposition.zspray,
            rptimeposition.gpsQuality,
            rptimeposition.GnssRMS,
            rptimeposition.GnssHDOP,
            rptimeposition.GnssVDOP,
            rptimeposition.GnssPDOP,
            rptimeposition.GnssAccuracyH,
            rptimeposition.GnssAccuracyV
        ]
    }

    getItemAtIndex(index) {
        return this.data[index];
    }

    //from xy
    getHeading(x1, y1, x2, y2) {
        var heading = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI * -1 + 90
        return heading < 0 ? heading + 360 : heading;
    }

    // y is lat x is lon https://www.igismap.com/formula-to-find-bearing-or-heading-angle-between-two-points-latitude-longitude/
    getHeading2(x1, y1, x2, y2) {
        function toRadians(angle) {
            return angle * (Math.PI / 180);
        }
        var x = Math.cos(toRadians(y2)) * Math.sin(toRadians(x2 - x1))
        var y = Math.cos(toRadians(y1)) * Math.sin(toRadians(y2)) - Math.sin(toRadians(y1)) * Math.cos(toRadians(y2)) * Math.cos(toRadians(x2 - x1))

        var heading = Math.atan2(x, y)
        var headingDeg = heading * 180 / Math.PI
        return headingDeg < 0 ? headingDeg + 360 : headingDeg;
    }
}

export default class AsBuildReport {
    constructor(name, projection, rptimepositions) {
        this.taskName = name;
        this.taskProjection = projection;

        this.headerarray = [];
        this.data = [];

        this.parseRptimepositionlogs(rptimepositions);
    }

    parseRptimepositionlogs(rptimepositions) {
        var duplicateLines = 0;
        rptimepositions.forEach((rptimeposition, i) => {
            if (i + 1 == rptimepositions.length) {
                this.data.push(new AsBuildReportLine(i + 1 - duplicateLines, rptimeposition, null));
            } else {
                try {
                    var line = rptimeposition
                    var nextLine = rptimepositions[i + 1]


                    if (line.xspray == nextLine.xspray &&
                        line.yspray == nextLine.yspray &&
                        line.zspray == nextLine.zspray &&
                        line.longitudeSpray == nextLine.longitudeSpray &&
                        line.latitudeSpray == nextLine.latitudeSpray &&
                        line.timestamp == nextLine.timestamp &&
                        abs(line.ms - nextLine.ms) < 5 && /**controleer deze */
                        line.gpsQuality == nextLine.gpsQuality &&
                        line.machineState == nextLine.machineState
                    ) {
                        console.log("DUPLICATE LINE")
                        duplicateLines++
                    } else {
                        this.data.push(new AsBuildReportLine(i + 1 - duplicateLines, line, nextLine));
                    }
                } catch (error) {
                    console.error("Something went wrong:")
                    console.error(error)
                }
            }
        });
    }

    getAsBuildReport(headersArray = [...Array(16).keys()]) {
        var firstLine = ["As build logging", "Task", this.taskName, "Projection", this.taskProjection];
        var header = [];
        var lines = [firstLine, header];

        headersArray.forEach(headerIndex => {
            header.push(this.getHeaderString(headerIndex))
        });
        this.data.forEach(line => {
            var lineArr = [];
            headersArray.forEach(headerIndex => {
                lineArr.push(line.getItemAtIndex(headerIndex));
            });
            lines.push(lineArr)
        })
        return stringify(lines);
    }

    getHeaderString(index) {
        var headers = [
            "Name",
            "LogReference",
            "DateTime",
            "Latitude",
            "Longitude",
            "X",
            "Y",
            "Heading",
            "Heigth",
            "GNSSQuality",
            "GNSS-RMS",
            "GNSS-HDOP",
            "GNSS-VDOP",
            "GNSS-PDOP",
            "GNSS-AccuracyH",
            "GNSS-AccuracyV"
        ]
        return headers[index];
    }
}